module.exports = __webpack_public_path__ + "static/media/gal0706.dbb231fd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/ressources/gal07/gal0706.jpg
// module id = 515
// module chunks = 0